import React, { useCallback, useState } from 'react';

// Components
import WpDateInput from '../WpDateInput';
import { WpForm, WpFormLayout } from '../../form';
import { WpButton } from '../../button';

const DatePickerDocs = () => {
  const WithoutForm = () => {
    const [date, setSelectedDate] = useState();
    const handleChange = value => {
      console.log('--value: ', value);
      setSelectedDate(value);
    };
    return <WpDateInput id="without_form_input" label="Choose a date" value={date} onChange={handleChange} />;
  };

  const FormExample = () => {
    const handleSubmit = useCallback(data => {
      console.log('submitted data: ', data);
      alert('submitted, see console.log for returned data');
    }, []);

    return (
      <>
        <h3>Form Example</h3>
        <WpForm onSubmit={handleSubmit}>
          <WpFormLayout>
            <WpDateInput
              id="start_date"
              label="Start Date"
              helpText="Your service will start on the selected date."
              required
            />
          </WpFormLayout>
          <WpButton btnType="submit">submit</WpButton>
        </WpForm>
      </>
    );
  };

  return (
    <div>
      <WithoutForm />
      <hr />
      <FormExample />
    </div>
  );
};

export default DatePickerDocs;
